import { Component, Renderer2, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { StorageService } from '@toro/common/shared/services/storage.service';
import { ActivatedRoute } from '@angular/router';

declare global {
  interface Window {
    /**
     * Check the ZenDesk SDK API in https://developer.zendesk.com/documentation/zendesk-web-widget-sdks/sdks/web/sdk_api_reference/
     */
    zE: any;
  }
}

@Component({
  selector: 'zendesk-help-button',
  templateUrl: './zendesk-help-button.component.html'
})
export class ZendeskHelpButtonComponent implements OnInit {
  public isTrader: boolean = false;
  public isInMobileApp: boolean = false;

  constructor(
    private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document,
    private route: ActivatedRoute
  ) {}

  public ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.isTrader =
        params.trader == 'true' ||
        StorageService.getCookie('hubUserTraderStatus') == 'true';
        this.injectZendeskScript();
    });
  }

  private injectZendeskScript() {
    const existingScript = this._document.getElementById('ze-snippet');
    if (existingScript) existingScript.remove();

    const script = this._renderer2.createElement('script');
    script.id = 'ze-snippet';
    script.src = this.isTrader
      ? 'https://static.zdassets.com/ekr/snippet.js?key=58184884-5d1e-4e4e-ba28-bd88e96c4172'
      : 'https://static.zdassets.com/ekr/snippet.js?key=4bcc3ab2-b526-4440-82bb-41049b83e5b7';

    this._renderer2.appendChild(this._document.body, script);
  }
}
